import Vue from "vue";
import VueRouter from "vue-router";
import shoprouters from "./shoprouter/index.js";

Vue.use(VueRouter);
const routes = [{
    path: "/",
    name: "root",
    // 重定向
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/HomePage/HomePage.vue"),
    meta: {
      title: '大板云仓',
      KeepAlive: true
    }
  },
  {
    path: "/scan",
    name: "Scan",
    component: () => import("../views/ScanPage/ScanPage.vue"),
    meta: {
      title: '共享云仓',
      KeepAlive: true
    }
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/AboutPage/AboutPage.vue"),
  },
  {
    path: "/detail/:stone_type/:stone_no/:thickness/:processing_surface/:mark",
    name: "Detail",
    component: () => import("../views/StoneDetailPage/StoneDetailPage.vue"),
    meta: {
      keepAlive: false
    } // 确保不缓存组件
  },
  {
    path: '/stone_type/:stone_type',
    name: 'StoneType',
    component: () => import('@/views/StoneTypePage/StoneTypePage.vue'),
    props: true
  },
  ...shoprouters,
];
const router = new VueRouter({
  //   mode: "history",
  //   base: process.env.BASE_URL,
  routes,
});
export default router;